<template>
	<v-row class="quick-filter-container" no-gutters>
		<v-col cols="3" class="flex-grow-0 flex-shrink-0">
			<v-autocomplete
				v-model="search.FieldId"
				label="Field"
				:items="quickSearchFields"
				class="quick-search-selector1 ml-4"
				item-text="Label"
				item-value="Id"
				hide-details
				dense
			/>
		</v-col>
		<v-col class="flex-grow-1 flex-shrink-1">
			<v-text-field
				v-model="search.Value"
				label="Search"
				class="quick-search-value"
				hide-details
				dense
				@keypress.enter="applyQuickFilter"
				:placeholder="dateFormat"
			>
				<template #append>
					<v-btn
						class="quick-search-action-btn"
						min-width="4rem"
						small
						text
						@click.stop="applyQuickFilter"
					>
						<v-icon> mdi-arrow-right </v-icon>
					</v-btn>
				</template>
			</v-text-field>
		</v-col>
		<v-col class="flex-grow-0 flex-shrink-0">
			<v-btn
				class="searchbar-toggle"
				title="Clear search"
				text
				@click="clearQuickSearch"
			>
				<v-icon> mdi-close </v-icon>
			</v-btn>
		</v-col>
	</v-row>
</template>
<script>
import { FieldDataTypes } from '../../../enums/fieldDataTypes';
import projectSettingsMixin from '../../../mixins/projectSettingsMixin';

export default {
	name: 'QuickFilter',
	mixins: [projectSettingsMixin],
	directives: {
		'click-outside': {
			bind: function (el, binding, vnode) {
				el.clickOutsideEvent = function (event) {
					if (event.target.closest('.v-list-item')) {
						return;
					}
					// here I check that click was outside the el and his children
					if (!(el === event.target || el.contains(event.target))) {
						// and if it did, call method provided in attribute value
						vnode.context[binding.expression](event);
					}
				};
				document.body.addEventListener('click', el.clickOutsideEvent);
			},
			unbind: function (el) {
				document.body.removeEventListener(
					'click',
					el.clickOutsideEvent
				);
			},
		},
	},
	props: {
		filter: Object,
		Columns: Array,
	},
	data() {
		return {
			showSearch: false,
			search: {
				FieldId: this.filter.FieldId,
				Value: this.filter.Value || '',
			},
		};
	},
	mounted() {
		if (this.openSearch) this.showSearch = true;
	},

	computed: {
		dateFormat() {
			if (
				this.search &&
				this.search.FieldId &&
				this.Columns &&
				this.Columns.length > 0
			) {
				let item = this.Columns.find(
					(x) => x.Id == this.search.FieldId
				);
				if (
					item &&
					item.DataField &&
					(item.DataField.DataType ==
						FieldDataTypes.AUTOGENERATED_DATETIME ||
						item.DataField.DataType == FieldDataTypes.DATETIME ||
						item.DataField.DataType == FieldDataTypes.DATE)
				) {
					return this.getDateFormatProjectSetting() + ' only';
				}
			}

			return null;
		},
		quickSearchFields() {
			if (!this.Columns) return [{ Id: null, Label: 'All' }];
			return [{ Id: null, Label: 'All' }, ...this.Columns];
		},
	},
	methods: {
		closeSearch() {
			this.showSearch = false;
		},
		clearQuickSearch() {
			this.search = { FieldId: null, Value: '' };
			this.applyQuickFilter();
		},
		applyQuickFilter() {
			this.$emit('filterChanged', this.search);
		},
	},
};
</script>
<style scoped>
@media only screen and (max-width: 600px) {
	.searchbar-toggle.v-btn.v-btn--text.theme--light.v-size--default {
		min-width: 0px;
		padding: 10px;
	}
}
</style>
